import React from 'react';

export const Footer = () => (
  <footer className="valuare-footer" data-testid="site-footer">
    <div className="valuare-footer-logos">
      <img
        src="https://customer-assets.emergentagent.com/job_valuare-jr-preview/artifacts/8mncgvt8_image.png"
        alt="CMVM - Comissão do Mercado de Valores Mobiliários"
        className="footer-logo-img"
      />
      <img
        src="https://customer-assets.emergentagent.com/job_valuare-jr-preview/artifacts/5ssl9m8k_Captura%20de%20ecr%C3%A3%202026-06-14%20193425.png"
        alt="ANAI - Associação Nacional de Avaliadores Imobiliários"
        className="footer-logo-img"
      />
    </div>

    <p>© 2025 Valuare JR · Avaliações Imobiliárias Certificadas</p>
    <p className="valuare-footer-gold">José Rodrigo Riscado · Perito Avaliador Certificado</p>
    <p style={{ fontSize: '0.65rem', marginTop: '16px', opacity: 0.7 }}>
      CMVM PAI/2025/0020 · ANAI 1267 · Normas EVS/TEGoVA
    </p>
  </footer>
);
